import { createStore } from 'zustand/vanilla';
import { createZustandContext } from './create-zustand-context';
import { Order, ProductCategory } from 'shared/@generated/models';

export interface ShopSettings {
  shipping_days_min: number;
  shipping_days_max: number;
  shipping_days_slow_min: number;
  shipping_days_slow_max: number;
  free_shipping_from_minor: number;
  shipping_fee_minor: number;
  minimum_order_value_minor: number;
  tax_percentage?: number;
}

export type ShopData = {
  productCategories: ProductCategory[];
  settings: ShopSettings | null;
};

interface ShopState {
  settings: ShopSettings | null;
  order: Order | null;
  productCategories: ProductCategory[];
  reset: () => void;
  setOrder: (order: Order | null) => void;
  setProductCategories: (productCategories: ProductCategory[]) => void;
  setSettings: (settings: ShopSettings | null) => void;
}

export const [ShopProvider, useShopStore, useShopStoreApi] = createZustandContext<ShopState>(
  (init) =>
    createStore<ShopState>()((set) => ({
      order: init.order ?? null,
      productCategories: init.productCategories ?? [],
      settings: init.settings ?? null,
      reset: () => set({ order: null }),
      setOrder: (order) => set({ order }),
      setProductCategories: (productCategories) => set({ productCategories }),
      setSettings: (settings) => set({ settings }),
    })),
);

export default useShopStore;
